module.exports = __webpack_public_path__ + "img/hohlschnitt_verkehrsgelb_ral1023.38d8865e.jpg";